export default "__VITE_ASSET__B1I_FJAL__"